// @flow
/* eslint-disable no-useless-escape */
import { getLogger } from '@jitsi/logger';
import { setPassword } from '../../../react/features/base/conference/actions';
import { translate } from '../../../react/features/base/i18n/functions';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import React, { PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import Keyboard from 'react-simple-keyboard';
import { Dispatch } from 'redux';
import { hideWildixModal } from '../../components/base/modal/actions';
import PasswordPinNavigation from '../../wizyconf/keyboard/PasswordPinNavigation';

import PopupOverlay from './PopupOverlay';

const logger = getLogger(__filename);

type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    hideWildixModal: Function,

    _physicalKeyPressed: String,

    /**
     * The {@code JitsiConference} for the current conference.
     */
    conference: Object,

    /**
     * The redux store's {@code dispatch} function.
     */
    dispatch: Dispatch<any>,
};

type State = {
    passwordTextInfo: String,
    passwordValue: String,
    showLoader: Boolean,
    lastIndex: Boolean
};

class WizyPopupPassword extends PureComponent<Props> {
    #backspaceName = '{bksp}';
    #maxPinLength = 6;
    #baseNavigation = {
        '38': this.arrowNavigation.bind(this, 'goToVerticalPrev'),
        '40': this.arrowNavigation.bind(this, 'goToVerticalNext'),
        '37': this.arrowNavigation.bind(this, 'goToHorizontalPrev'),
        '39': this.arrowNavigation.bind(this, 'goToHorizontalNext'),
        '13': this.arrowNavigation.bind(this, 'triggerClickOnBtn')
    };

    state: State = {
        passwordTextInfo: null,
        passwordValue: '',
        showLoader: false,
        lastIndex: false
    };

    constructor(props: Props) {
        super(props);
        this.indexInputRef = 0;
        this.arrayInviteInputs = [];
        this.passwordPinNavigation = null;

        this.addEvents();
        this.createInputRefs();

    }

    /**
     *
     */
    componentDidUpdate(prevProps) {
        if (prevProps._physicalKeyPressed !== this.props._physicalKeyPressed) {
            this.windowKeyPressed();
        }
    }

    /**
     *
     */
    arrowNavigation(functionName) {
        if (this.passwordPinNavigation[functionName]) {
            this.passwordPinNavigation[functionName]();
        }
    }

    /**
     *
     */
    windowKeyPressed() {
        const keyCode = this.props._physicalKeyPressed.which;

        if (this.#baseNavigation[keyCode] && !this.state.showLoader) {
            this.#baseNavigation[keyCode]();
        }
    }

    onKeyboardLoaded() {
        this.passwordPinNavigation = new PasswordPinNavigation();
    }

    /**
     *
     */
    addEvents() {
        const getConference = APP.conference.__getJitsiConference();

        getConference.addEventListener(JitsiConferenceEvents.CONFERENCE_JOINED, () => {
            this.props.hideWildixModal();
            logger.log('Joined with password');
        });
    }

    /**
     *
     */
    initConference = password => {
        const { conference } = this.props;

        this.props.dispatch(setPassword(conference, conference.join, password));
    };

    /**
     *
     */
    onChange = () => {
        this.checkInvitePin();
    };

    /**
     *
     */
    onKeyPress = button => {
        this.setValueAndChangeInput(button);
    };

    /**
     *
     */
    checkInvitePin() {
        if (this.indexInputRef < this.#maxPinLength) {
            return false;
        }

        const { t } = this.props;

        this.setState({
            showLoader: true,
            lastIndex: true
        });
        APP.wildixPBX.getAuthToken().then(token => {
            const headers = APP.wildixApiMethods.addAuthHeader(token);

            APP.WildixAPI.PasswordFromPin.get(this.state.passwordValue, {}, headers)
                .then(({ result }) => {
                    if (result) {
                        this.initConference(result);

                        return;
                    }

                    this.arrowNavigation('setLastElement');
                    this.indexInputRef--;
                    this.setState({
                        passwordTextInfo: t('password.wrongPin'),
                        showLoader: false
                    });
                })
                .catch(e => {
                    logger.error(e);
                    this.setState({
                        passwordTextInfo: t('dialog.conferenceReloadTitle'),
                        showLoader: false
                    });
                });
        })
            .catch(authTokenError => {
                logger.error(authTokenError);
            });

    }

    /**
     *
     */
    createInputRefs() {
        for (let i = 0; i < this.#maxPinLength; i++) {
            this.arrayInviteInputs.push(
                this[`input-ref_${i}`] = createRef()
            );
        }
    }

    /**
     *
     */
    setValueAndChangeInput(button) {
        const { lastIndex, passwordValue } = this.state;

        if (button === this.#backspaceName) {
            if (this.indexInputRef <= 0) {
                return;
            }
            if (!lastIndex) {
                this.indexInputRef--;
            }
            this.setState({
                lastIndex: false,
                passwordTextInfo: null,
                passwordValue: passwordValue.slice(0, -1)
            });
            this[`input-ref_${this.indexInputRef}`].current.value = '';
        } else {
            if (this.indexInputRef >= this.#maxPinLength || lastIndex) {
                return;
            }
            this[`input-ref_${this.indexInputRef}`].current.value = button;
            this.indexInputRef++;
            this.setState({
                passwordValue: passwordValue.concat(button)
            });

        }

    }

    /**
     *
     */
    iconDeleteSvg() {
        return '<svg viewBox="0 0 34 29" fill="none" xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M28.2617 28.0273C31.4253 28.0273 33.0146 26.4683 33.0146 23.335V4.85303C33.0146 1.71973 31.4253 0.160645 28.2617 0.160645H15.1079C13.3369 0.160645 11.8081 0.614746 10.5669 1.93164L1.65137 11.1953C0.66748 12.2095 0.213379 13.1177 0.213379 14.0713C0.213379 15.0098 0.652344 15.9331 1.65137 16.9473L10.582 26.1655C11.8384 27.4673 13.3521 28.0122 15.123 28.0122L28.2617 28.0273ZM28.2314 25.5903H15.0776C13.9272 25.5903 13.2158 25.3179 12.4136 24.5005L3.54346 15.3428C3.02881 14.813 2.87744 14.4497 2.87744 14.0713C2.87744 13.6777 3.04395 13.3145 3.54346 12.7847L12.3984 3.59668C13.1855 2.79443 13.9272 2.59766 15.0625 2.59766H28.2314C29.7451 2.59766 30.5776 3.3999 30.5776 4.97412V23.2139C30.5776 24.7881 29.7451 25.5903 28.2314 25.5903ZM14.23 20.4893C14.563 20.4893 14.8657 20.353 15.0928 20.1108L19.3916 15.7969L23.6904 20.1108C23.9175 20.3379 24.2202 20.4893 24.5684 20.4893C25.2344 20.4893 25.7793 19.9292 25.7793 19.2632C25.7793 18.915 25.6431 18.6274 25.416 18.4004L21.1172 14.1016L25.4312 9.77246C25.6733 9.51514 25.7944 9.25781 25.7944 8.9248C25.7944 8.24365 25.2495 7.71387 24.5835 7.71387C24.2656 7.71387 23.9932 7.81982 23.7358 8.07715L19.3916 12.4062L15.0625 8.09229C14.8354 7.8501 14.563 7.74414 14.23 7.74414C13.564 7.74414 13.019 8.25879 13.019 8.93994C13.019 9.27295 13.1401 9.56055 13.3823 9.7876L17.6812 14.1016L13.3823 18.4155C13.1401 18.6274 13.019 18.9302 13.019 19.2632C13.019 19.9292 13.564 20.4893 14.23 20.4893Z" fill="white"/>'
            + '</svg>';

    }

    render() {
        const { t } = this.props;
        const { passwordTextInfo, showLoader } = this.state;

        return (
            <PopupOverlay className={'wizy-popup__password popup_opacity_8'}>
                <div className="dialog-content text-center flex_center">
                    {showLoader && <div className="preloader position-center"></div> }
                    <div className="dialog-content__wrapper" style = {{
                        visibility: showLoader ? 'hidden' : 'visible'
                    }}>
                        <h3 className="invite-main__title"> {t('password.wizyMainTitle')}</h3>
                        <h5 className="invite-second__title">{t('password.wizySecondTitle')}</h5>
                        <div className="invite-content">
                            <div className="inputs__wrapper flex_center">
                                {this.arrayInviteInputs.map((thing, index) =>
                                    <input className={`input-pin ${this.indexInputRef === index ? 'input-active' : ''}`}
                                        key={index} ref={this[`input-ref_${index}`]}
                                        disabled={'disabled'}/>
                                )}
                            </div>
                            {passwordTextInfo && <span className='invite__error-text color-red'>{passwordTextInfo}</span>}
                        </div>
                        <div className="password-keyboard">
                            <Keyboard
                                keyboardRef={ref => this.keyboard = ref}
                                layoutName={'default'}
                                onChange={this.onChange}
                                onKeyPress={this.onKeyPress}
                                onInit={this.onKeyboardLoaded.bind(this)}
                                theme={'hg-theme-default hg-layout-numeric numeric-theme wizy-pad'}
                                disableButtonHold={true}
                                useMouseEvents={true}
                                useButtonTag={false}
                                layout={{
                                    default: [ '1 2 3', '4 5 6', '7 8 9', `empty 0 ${this.#backspaceName}` ]
                                }}
                                display={{
                                    [this.#backspaceName]: this.iconDeleteSvg()
                                }}
                            />
                        </div>
                        <p>
                            {t('password.wizyText')}
                        </p>
                    </div>

                </div>
            </PopupOverlay>
        );
    }
}

function _mapStateToProps(state) {
    const { keyboardEvent } = state['wildix/features/virtual-keyboard'];

    return {
        _physicalKeyPressed: keyboardEvent
    };
}

function _mapDispatchToProps(dispatch) {
    return {
        hideWildixModal: () => dispatch(hideWildixModal())
    };
}

export default translate(connect(_mapStateToProps, _mapDispatchToProps)(WizyPopupPassword));
